import React from 'react';
import {container, input} from "./accounts.module.css";

export default function accounts() {
  return(
    <form className={container}> 
      <label>
        <p>Username</p>
        <input className={input} type="text" />
      </label>
      <label>
        <p>Password</p>
        <input className={input} type="password" />
      </label>
      <div>
        <button type="submit">Submit</button>
      </div>
    </form>
  )
}
